import React from 'react'

export const Add = ({ styles, className = '', fill="none" }) => {
	return (
		<svg width='12' height='12' viewBox='0 0 12 12' fill={fill} xmlns='http://www.w3.org/2000/svg' style={styles} className={className}>
			<path d='M6.74868 5.25132V0H5.25132V5.25132H0V6.74868H5.25132V12H6.74868V6.74868H12V5.25132H6.74868Z' />
		</svg>
	)
}
